import React, { useState } from "react";
import { useFilterMap } from "../../../context/FilterMapContext";

interface PropsType {
  open: boolean;
  onClose: () => void;
  className?: string;
}
function BaseMapsOptions({ open, className, onClose }: PropsType) {
  const [styleMap, setStyleMap] = useState("topography");
  const { onSelectBaseMap } = useFilterMap();
  const handleSelectBaseMap = (style: string) => {
    setStyleMap(style);
    onSelectBaseMap(style);
  };
  return (
    <div className="relative">
      {open && (
        <div
          className={`absolute -right-8 md:right-0 top-0 w-[300px] h-[294px] bg-primary-contrast z-20 p-6 shadow-z8 rounded-[24px] flex flex-col gap-2 ${
            className ?? ""
          }`}
        >
          <div className="flex justify-between">
            <p className="text-sm text-text-primary font-normal">แผนที่ฐาน</p>
            <button className="w-auto h-auto" onClick={onClose}>
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.2516 4.75819C14.9266 4.43319 14.4016 4.43319 14.0766 4.75819L10.0016 8.82485L5.92656 4.74985C5.60156 4.42485 5.07656 4.42485 4.75156 4.74985C4.42656 5.07485 4.42656 5.59985 4.75156 5.92485L8.82656 9.99985L4.75156 14.0749C4.42656 14.3999 4.42656 14.9249 4.75156 15.2499C5.07656 15.5749 5.60156 15.5749 5.92656 15.2499L10.0016 11.1749L14.0766 15.2499C14.4016 15.5749 14.9266 15.5749 15.2516 15.2499C15.5766 14.9249 15.5766 14.3999 15.2516 14.0749L11.1766 9.99985L15.2516 5.92485C15.5682 5.60819 15.5682 5.07485 15.2516 4.75819Z"
                  fill="#8E8E8E"
                />
              </svg>
            </button>
          </div>
          <button
            className={`w-full h-auto p-2 rounded-[14px] flex flex-row gap-6  border-[1px] ${
              styleMap === "satellite"
                ? "border-primary-main bg-primary-light"
                : "bg-primary-contras border-gray-1 hover:bg-primary-main hover:bg-opacity-25"
            }`}
            onClick={() => handleSelectBaseMap("satellite")}
          >
            <img
              className="w-12 h-12 rounded-lg"
              src="/images/satellite.png"
              alt="satellite map"
            />
            <p className="text-sm text-text-primary font-normal self-center">
              Satellite
            </p>
          </button>
          <button
            className={`w-full h-auto p-2 rounded-[14px] flex flex-row gap-6  border-[1px] ${
              styleMap === "topography"
                ? "border-primary-main bg-primary-light"
                : "bg-primary-contras border-gray-1 hover:bg-primary-main hover:bg-opacity-25"
            }`}
            onClick={() => handleSelectBaseMap("topography")}
          >
            <img
              className="w-12 h-12 rounded-lg"
              src="/images/topography.png"
              alt="topography map"
            />
            <p className="text-sm text-text-primary font-normal self-center">
              Topography
            </p>
          </button>
          <button
            className={`w-full h-auto p-2 rounded-[14px] flex flex-row gap-6  border-[1px] ${
              styleMap === "hybrid"
                ? "border-primary-main bg-primary-light"
                : "bg-primary-contras border-gray-1 hover:bg-primary-main hover:bg-opacity-25"
            }`}
            onClick={() => handleSelectBaseMap("hybrid")}
          >
            <img
              className="w-12 h-12 rounded-lg"
              src="/images/hybrid.png"
              alt="hybrid map"
            />
            <p className="text-sm text-text-primary font-normal self-center">
              Hybrid
            </p>
          </button>
        </div>
      )}
    </div>
  );
}
export default BaseMapsOptions;
